import { combineReducers } from 'redux'

import application from './application'
import accounting from './accounting'
import order from './order'

export default combineReducers({ 
    application,
    order,
    accounting
})